<template>
  <section id="business">

    <b-container>
      <h5>
        Business areas
      </h5>
      <b-row>

        <b-col cols="12" lg="6" class="position-relative business" :class="block[0].active">
          <div class="business-teaser-container">
            <p class="business-teaser-text">Business area</p>
            <h3 class="business-teaser-headline">Decor</h3>
          </div>

          <div class="btn-container">
            <a 	:href="$creo.browserPdfLink(pdfLinks.full, pdfLinks.decor, 16)"
	            	class="btn btn-black-trans"
		            target="_blank">
		          Learn more
		        </a>
          </div>
        </b-col>

        <b-col cols="12" lg="6" class="position-relative business" :class="block[1].active">
          <div class="business-teaser-container">
            <p class="business-teaser-text">Business area</p>
            <h3 class="business-teaser-headline">Filtration and<br>
              Performance</h3>
          </div>

          <div class="btn-container">
            <a 	:href="$creo.browserPdfLink(pdfLinks.full, pdfLinks.filtration, 18)"
		            class="btn btn-black-trans"
			          target="_blank">
			            Learn more
		          </a>
          </div>
        </b-col>

        <b-col cols="12" lg="6" class="position-relative business" :class="block[2].active">
          <div class="business-teaser-container">
            <p class="business-teaser-text">Business area</p>
            <h3 class="business-teaser-headline">Industrial<br>
              Solutions</h3>
          </div>

          <div class="btn-container">
            <a 	:href="$creo.browserPdfLink(pdfLinks.full, pdfLinks.industrial, 20)"
		            class="btn btn-black-trans"
			          target="_blank">
			            Learn more
		          </a>
          </div>
        </b-col>

        <b-col cols="12" lg="6" class="position-relative business" :class="block[3].active">
          <div class="business-teaser-container">
            <p class="business-teaser-text">Business area</p>
            <h3 class="business-teaser-headline">Specialties</h3>
          </div>

          <div class="btn-container">
            <a 	:href="$creo.browserPdfLink(pdfLinks.full, pdfLinks.specialities, 22)"
		            class="btn btn-black-trans"
			          target="_blank">
			            Learn more
		          </a>
          </div>
        </b-col>

      </b-row>
    </b-container>
  </section>
</template>

<script>
  import full from '../assets/pdf/full-report.pdf';
  import decor from '../assets/pdf/decor.pdf';
  import industrial from '../assets/pdf/industrial.pdf';
  import filtration from '../assets/pdf/filtration.pdf';
  import specialities from '../assets/pdf/specialities.pdf';

  export default {
    name: 'Business',
    data() {
      return {
        pdfLinks: {
          'full': full,
          'decor': decor,
          'filtration': filtration,
          'industrial': industrial,
          'specialities': specialities
        },
        block: [{
          active: 'business-b1-one',
          imgClass: [
            'business-b1-one',
            'business-b1-two'
          ]
        },
        {
          active: 'business-b2-one',
          imgClass: [
            'business-b2-one',
            'business-b2-two'
          ]
        },
        {
          active: 'business-b3-one',
          imgClass: [
            'business-b3-one',
            'business-b3-two'
          ]
        },
        {
          active: 'business-b4-one',
          imgClass: [
            'business-b4-one',
            'business-b4-two'
          ]
        }]
      }
    },
    methods: {
      getRandomImg() {
        setInterval(this.setRandomClass.bind(this), 2000)
      },
      setRandomClass() {
        var block = Math.floor(Math.random() * Math.floor(4));
        var activeImg   = Math.floor(Math.random() * Math.floor(2));
        if(this.block[block].active == this.block[block].imgClass[activeImg]) {
          this.setRandomClass();
        }
        else {
          this.block[block].active = this.block[block].imgClass[activeImg]
        }

      }
    },
    mounted() {
      this.getRandomImg();
    }

  }

</script>



// WEBPACK FOOTER //
// src/sections/Business.vue